import { render, staticRenderFns } from "./OxygenMediaSizeInput.vue?vue&type=template&id=7ab6489a&scoped=true&"
import script from "./OxygenMediaSizeInput.vue?vue&type=script&lang=ts&"
export * from "./OxygenMediaSizeInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ab6489a",
  null
  
)

export default component.exports